function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-seuilniveau");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-seuilniveau",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,11.5 L14,13.5 M16,13.5 L15,11.5 M2.5,13.5 L27.5,13.5 M15,15.5 L14,17.5 M16,17.5 L15,15.5 M2.5,17.5 L27.5,17.5",
  id: "Combined-Shape"
})));

const SvgIco30Seuilniveau = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Seuilniveau, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-seuilniveau.e88fdc38.svg";
export { ForwardRef as ReactComponent };